// Rechnungsanschrift für die Korrekturanfrage (Ticket #423, Björn 22.09.2026).
//
// Die Vorlage schrieb „Bitte senden Sie uns die korrigierte Rechnung an diese Adresse" —
// nannte die Adresse aber nie. Sie steht jetzt im Text, mit dem echten Eigentümer statt
// eines Platzhalters.
//
// Aufbau: Der Eigentümer ist der Rechnungsempfänger, die Verwaltung nimmt die Post
// entgegen (c/o). Ohne hinterlegten Eigentümer bleibt die Namenszeile weg — lieber eine
// Adresse ohne Namen als die Zeile „(Eigentümer)" im Brief an den Lieferanten.
import { eigentuemerAnzeigename, type EigentuemerNameFelder } from '../eigentuemer/anzeige';

/** Anschrift der Verwaltung. Einzige Stelle — steht sonst nur im OCR-Prompt der Erkennung. */
export const VERWALTUNG_ANSCHRIFT = [
  'c/o Immobilienmanagement Schwede',
  'Marburger Ring 32a',
  '35274 Kirchhain',
];

/** Verwaltung als Absender/Zahlungsempfänger (ohne „c/o“): Name, Straße, PLZ Ort. */
export const VERWALTUNG_ABSENDER = VERWALTUNG_ANSCHRIFT.map((z, i) => (i === 0 ? z.replace(/^c\/o\s+/i, '') : z));

/** Zeilen der Rechnungsanschrift, von oben nach unten. */
export function anschriftZeilen(eigentuemer: EigentuemerNameFelder | null | undefined): string[] {
  const name = eigentuemer ? eigentuemerAnzeigename(eigentuemer) : '';
  // eigentuemerAnzeigename liefert bei leeren Feldern bewusst „—" — das ist ein Anzeigezeichen
  // für die Oberfläche und hat im Brief nichts zu suchen.
  const brauchbar = name && name !== '—' ? name : '';
  return brauchbar ? [brauchbar, ...VERWALTUNG_ANSCHRIFT] : [...VERWALTUNG_ANSCHRIFT];
}

const ESCAPE: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };

/** Für die HTML-Vorlage: Zeilenumbrüche als <br>, Name escaped (Firmen wie „Meyer & Sohn"). */
export function anschriftHtml(eigentuemer: EigentuemerNameFelder | null | undefined): string {
  return anschriftZeilen(eigentuemer)
    .map((z) => z.replace(/[&<>"]/g, (c) => ESCAPE[c]))
    .join('<br>');
}
